
(function ($, Drupal, dBlazy, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.LiftTeasersSliderNoLift = {
    computeHeight: function () {
      if ($(window).width() < 767) {
        $('.view-lift-teasers.view-display-id-nine_teaser_display_no_lift .view-content').css('height', 'auto');
      }
      else {
        var teaserHeight = $('.view-lift-teasers.view-display-id-nine_teaser_display_no_lift .views-row').outerHeight();
        $('.view-lift-teasers.view-display-id-nine_teaser_display_no_lift .view-content').css('height', teaserHeight + 'px');
      }
    },
    initLiftTeaserSlider: function () {
      var liftTeasers = $('.view-lift-teasers.view-display-id-nine_teaser_display_no_lift .view-content');
      var me = Drupal.blazy;

      if ($(window).width() > 767) {
        if (liftTeasers.hasClass('slick-initialized')) {
          liftTeasers.slick('unslick');
        }
      }
      else if ($(window).width() < 767) {
        if (liftTeasers.length && !liftTeasers.hasClass('slick-initialized')) {
          liftTeasers.each(function () {
            $(this).slick({
              arrows: false,
              useCss: true,
              infinite: false,
              centerMode: true,
              centerPadding: '15px',
              variableWidth: true,
              slidesToShow: 1,
              accessibility: false,
              focusOnSelect: true
            });

            $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
              me.init.revalidate();
            });
          });
        }
      }
    },
    attach: function () {
      window.addEventListener('acquiaLiftContentAvailable', function (e) {
        Drupal.behaviors.LiftTeasersSliderNoLift.initLiftTeaserSlider();
        Drupal.behaviors.LiftTeasersSliderNoLift.computeHeight();

        $(window).resize(function () {
          Drupal.behaviors.LiftTeasersSliderNoLift.initLiftTeaserSlider();
          if (!$('.view-lift-teasers.view-display-id-nine_teaser_display_no_lift .view-content').hasClass('full-height')) {
            Drupal.behaviors.LiftTeasersSliderNoLift.computeHeight();
          }
        });

        $(once('showmore', '.view-lift-teasers.view-display-id-nine_teaser_display_no_lift .view-footer a')).click(function (e) {
          if ($(window).width() > 767 && !$('.view-lift-teasers.view-display-id-nine_teaser_display_no_lift .view-content').hasClass('full-height')) {
            e.preventDefault();
            $('.view-lift-teasers.view-display-id-nine_teaser_display_no_lift .view-content').addClass('full-height');
            $('.view-lift-teasers.view-display-id-nine_teaser_display_no_lift .view-content').css('height', 'auto');
          }
        });
      });
    }
  };
})(jQuery, Drupal, dBlazy, drupalSettings, once); // eslint-disable-line no-undef
